import React, { useState } from 'react';
import Button from 'react-bootstrap/Button'
import Accordion from 'react-bootstrap/Accordion'
//import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import Card from 'react-bootstrap/Card'
import {
    IoIosArrowDown,
    IoIosArrowForward
} from 'react-icons/io';

import './MoreInfoBox.css'

export default function MoreInfoBox(props) {
    const [isCollapsed, setIsCollapsed] = useState(props.startCollapsed || false);


    // const decoratedOnClick = useAccordionToggle(eventKey, () => {
    //         callback && callback(eventKey)
    //     }
    // );

    let clicked = ((e) => {
        e.preventDefault();
        setIsCollapsed(!isCollapsed)
    })

    return (
        <Accordion className="more-info-box"
                defaultActiveKey={props.startCollapsed ? (null) : ("0")}>
            <Accordion.Toggle as={Button} variant="link" eventKey="0"
                onClick={ clicked }>
                { (isCollapsed) ? (
                    <IoIosArrowForward />
                  ) : (
                    <IoIosArrowDown />
                  )
                } {props.toggleText || 'More Info'}
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
                <Card>
                    <Card.Body>
                        {props.children}
                    </Card.Body>
                </Card>
            </Accordion.Collapse>
        </Accordion>
    )
}
